import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/category/view/layer.category.view.query.gql"
import type {
  LayerCategoryViewQuery,
  LayerCategoryViewQueryVariables,
} from "@/v2-backoffice-client/layer/category/view/__types__/layer.category.view.query"

type Options = QueryHookOptions<
  LayerCategoryViewQuery,
  LayerCategoryViewQueryVariables
>

export function useLayerCategoryViewQuery(options?: Options) {
  return useQuery<LayerCategoryViewQuery, LayerCategoryViewQueryVariables>(
    query,
    options,
  )
}
